<template>
<tr class="item">
  <td>{{ block.number }}</td>
  <td><input type="text" class="form-control" v-model="block.start" /></td>
  <td><input type="text" class="form-control" v-model="block.end" /></td>
  <td>
    <input type="button" class="btn btn-danger" :value="__('button.delete')" @click="$emit('delete', idx)">
  </td>
</tr>
</template>

<script>

export default {
  name: "Block",
  props: ['block', 'idx'],
  data() {
    return {
      message: '',
    }
  }
}
</script>
